import React, { useState } from "react";
import AuthService from "services/auth.service";
import Modal from "components/Modal/Modal";
import { ReactComponent as UserIcon } from "../assets/img/Usericon.svg";
import { ReactComponent as Setting } from "../assets/img/setting-icon.svg";
import { ReactComponent as Help } from "../assets/img/help-circle.svg";
import { ReactComponent as Phone } from "../assets/img/call.svg";
import { ReactComponent as ArrowR } from "../assets/img/arrow-right.svg";
import {API_URL_IMAGE} from "../services/config";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";

import defaultImage from "../assets/img/default-avatar.png";
import { ImportsNotUsedAsValues } from "typescript";

function User() {
  const currentUser = AuthService.getCurrentUser();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const handleOptionClick = (content) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  //logic for profile image

  

  const imageDir = currentUser.imageURL;
  let profileImage = `${API_URL_IMAGE}${imageDir}`;

  // Check if imageURL ends with 'none', if yes, use the default image
  if (profileImage.endsWith("none")) {
    profileImage = defaultImage;
  }

  return (
    <>
      {/* this is for web  */}
      <div className="content jag-web">
        <Row>
          <Col className="jag-web-profile">
            <Card className="card-user outer-line">
              <CardHeader>
                <CardTitle tag="h5">Profile Details</CardTitle>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col className="" md="4">
                      <FormGroup>
                        <label>First Name</label>
                        <Input
                          defaultValue={currentUser.firstName}
                          placeholder="Company"
                          type="text"
                        />
                      </FormGroup>
                    </Col>
                    <Col className="" md="4">
                      <FormGroup>
                        <label>Last Name</label>
                        <Input
                          defaultValue={currentUser.lastName}
                          placeholder="Last Name"
                          type="text"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="" md="4">
                      <FormGroup>
                        <label>Email</label>
                        <Input
                          disabled
                          defaultValue={currentUser.email}
                          placeholder="Email address"
                          type="text"
                        />
                      </FormGroup>
                    </Col>
                    <Col className="" md="4">
                      <FormGroup>
                        <label>Mobile Number</label>
                        <Input
                          disabled
                          defaultValue={currentUser.mobileNumber}
                          placeholder="mobile number"
                          type="text"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="" md="4">
                      <FormGroup>
                        <label>DOB</label>
                        <Input
                          defaultValue={currentUser.dateOfBirth}
                          placeholder="YYYY/MM/DD"
                          type="text"
                        />
                      </FormGroup>
                    </Col>
                    <Col className="" md="4">
                      <FormGroup>
                        <label>Gender</label>

                        <Input
                          defaultValue={currentUser.gender}
                          placeholder="Gender"
                          type="text"
                          disabled
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    {/* <Col className="" md="4">
                      <FormGroup>
                        <label>SSN</label>
                        <Input
                          disabled
                          defaultValue={currentUser.ssn}
                          placeholder="number"
                          type="text"
                        />
                      </FormGroup>
                    </Col> */}
                    <Col className="" md="4">
                      <FormGroup>
                        <label>Address</label>
                        <Input
                          defaultValue={currentUser.address}
                          placeholder="Home Address"
                          type="text"
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <div className="update ml-3">
                      <Button
                        className="btn-round profile-update-but"
                        color="primary"
                        type="submit"
                      >
                        Save Changes
                      </Button>
                    </div>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      {/* this is for mobile  */}
      <div className="jag-profile">
        <div className="jag-profile-header">
          <h2> User Profile</h2>
        </div>
        <div className="jag-user-profile">
          <img src={profileImage} alt="User Avatar" className="jag-avatar" />
          <div className="jag-user-profile-info">
            <h2>
              {currentUser.firstName} {currentUser.lastName}
            </h2>
            <p>{currentUser.email}</p>
          </div>
        </div>
        <div className="jag-options">
          <div onClick={() => handleOptionClick("My Account")}>
            {" "}
            <UserIcon className="jag-icons"/> My Account{" "} <ArrowR  className="jag-arwR"/>
          </div>
          <div onClick={() => handleOptionClick("Settings")}>
            {" "}
            <Setting className="jag-icons"/> Settings <ArrowR  className="jag-arwR"/>
          </div>
          <div onClick={() => handleOptionClick("Help Center")}>
            {" "}
            <Help className="jag-icons"/>
            Help Center <ArrowR  className="jag-arwR"/>
          </div>
          <div onClick={() => handleOptionClick("Contact")} className="nild">
            <Phone className="jag-icons"/> Contact <ArrowR  className="jag-arwR"/>
          </div>
        </div>
        {isModalOpen && (
          <Modal content={modalContent} setIsModalOpen={setIsModalOpen} />
        )}
      </div>
    </>
  );
}

export default User;
